export default __webpack_public_path__ + "static/media/feather _ arrow-up.4c3b9057.svg";